import React from "react";
import withStyles from "react-jss";

const styles = theme => ({
    root: {
        padding: "30px",
        overflow: "hidden",
        width: "100%",
        borderRadius: "10px",
        backgroundColor: "#ffffff",
        border: "solid 1px #d3cee1",
    },
    [`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
        root: {
            width: "100%",
            marginTop: "0",
            marginBottom: "20px",
        },
    },
    [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
        root: {
            padding: "20px",
            width: "100%",
            marginTop: "0",
            marginBottom: "10px",
        },
    },
    [`@media (max-width: ${theme.media.sm})`]: {
        root: {
            padding: "20px 8.33% 30px",
            width: "100%",
            marginTop: "0",
            marginBottom: "10px",
        },
    },
    "@media (max-width: 520px)": {},
});
const TableRating = ({ classes, children }) => {
    return <div className={classes.root}>{children}</div>;
};
export default withStyles(styles)(TableRating);
